import ScreenOne from "../assets/img/screen1.png";
import Decoration from "../assets/img/decoration.png";
import CurveArrow from "../assets/img/knvkfv.png";
import IconLogo from "../assets/img/icon-logo.png";

const Landing = () => {
    return (
        <div className='min-h-full lg:min-h-0 lg:h-[calc(100%-90px)] gap-9 flex flex-col lg:flex-row px-[15px] xs:px-[30px] lg:px-[57px] justify-center items-center relative'>
            <div className="animate-ltr-l absolute bg-[rgba(1,194,240,0.2)] blur-[1000px] left-[-461px] top-[-20px] w-full h-full z-0"></div>
            <div className="animate-rtl-l absolute bg-[rgba(15,216,138,0.2)] blur-[1000px] right-[-230px] top-[-20px] w-full h-full z-0"></div>
            <div className='flex flex-col lg:h-full gap-0 justify-center lg:mt-0 relative'>
                <div className="relative">
                    <div className="text-[#353736] not-italic font-[800] text-[28px] sm:text-[36px] md:text-[60px] text-center lg:text-left leading-[32px] sm:leading-[42px] md:leading-[75px]">
                    Next Evolution AMM-based DEX built on Cardano 
                    </div>
                    <div className="text-[#353736] not-italic font-[500] text-[18px] sm:text-[20px] md:text-[24px] text-center lg:text-left leading-[20px] mt-2 sm:mt-0 sm:leading-[12px] md:leading-[34px]">
                    Pioneering the Ultimate Cardano DeFi Ecosystem 
                    </div>
                    <div className="flex flex-col sm:flex-row gap-5 justify-center lg:justify-start items-center lg:items-start mt-10">
                        <a href="#0" className="bg-btn inline-flex relative rounded-[30px] text-white not-italic font-[500] text-[15px] lg:text-[17px] py-[8px] xs:py-[7px] sm:py-[8px] lg:py-[8px] px-6 leading-[150%] text-center">Telegram</a>
                        <a href="#0" className="bg-btn inline-flex relative rounded-[30px] text-white not-italic font-[500] text-[15px] lg:text-[17px] py-[8px] xs:py-[7px] sm:py-[8px] lg:py-[8px] px-6 leading-[150%] text-center">Documentation</a>
                    </div>
                    <img src={IconLogo} alt="icon-logo" className="App-logo absolute top-[-50px] sm:top-0 right-[20px] z-10 w-[50px]" />
                </div>
            </div>
            <div className='flex lg:h-full items-center justify-center relative'>
                <div className="w-[70%] w-full lg:w-[45vw] h-full flex flex-row justify-center items-center">
                    <div className="relative w-full h-full flex items-center">
                        <div>
                        <img src={Decoration} alt="decoration" className="absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-0 w-[85%]" />
                        <img src={CurveArrow} alt="arrow" className="absolute right-0 sm:right-[95px] md:right-[130px] lg:right-[95px] z-0 w-[80px] top-[80px]" />
                        <img src={ScreenOne} alt="phone-screen" className="w-[50%] sm:w-[43%] mx-[auto] flex z-5 relative" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Landing;